import { IconButton, IconButtonProps, SvgIconProps } from '@mui/material';

import DeleteIcon from '../../../assets/icons/Delete';
import colors from '../../../constants/colors';

interface DeleteButtonProps extends IconButtonProps {
  iconProps?: SvgIconProps;
}

const DeleteButton = ({ iconProps, sx, ...props }: DeleteButtonProps) => {
  return (
    <IconButton
      disableRipple
      {...props}
      sx={{
        ':focus': {
          outline: `2px solid ${colors.csaaSpectrumRed50}`,
        },
        '&:hover': {
          backgroundColor: colors.redInteractiveButtonHover,
        },
        ...sx,
      }}
    >
      <DeleteIcon />
    </IconButton>
  );
};

export default DeleteButton;
